import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a38cb2dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a38cb2dc&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=a38cb2dc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38cb2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a38cb2dc')) {
      api.createRecord('a38cb2dc', component.options)
    } else {
      api.reload('a38cb2dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a38cb2dc&scoped=true", function () {
      api.rerender('a38cb2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelsmanage/index.vue"
export default component.exports